// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/WhatsappMessageTemplates_BuscaWhatsappMessageTemplateResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/whatsapp_message_templates/buscaWhatsappMessageTemplate/{template_id}.
 *
 * Returns a single WhatsApp message template enriched with its associated
 * franquia_ids (int[]). 404-style "not found" cases are emitted via sendError().
 */
import type { WhatsappMessageTemplates_BuscaTemplateRow } from './WhatsappMessageTemplates_BuscaTemplateRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type WhatsappMessageTemplates_BuscaWhatsappMessageTemplateResponseDados = WhatsappMessageTemplates_BuscaTemplateRow;

export type WhatsappMessageTemplates_BuscaWhatsappMessageTemplateResponse = ApiResponse<WhatsappMessageTemplates_BuscaWhatsappMessageTemplateResponseDados>;

registerResponseContract('WhatsappMessageTemplates_BuscaWhatsappMessageTemplateResponse', {
  template_id:        { type: 'number',  required: true },
  template_name:      { type: 'string',  required: true },
  template_content:   { type: 'string',  required: true },
  template_type:      { type: 'string',  required: true },
  template_media_url: { type: 'string',  required: false },
  is_active:          { type: 'number',  required: true },
  created_at:         { type: 'string',  required: true },
  updated_at:         { type: 'string',  required: true },
  franquia_ids:       { type: 'array',   required: false },
})
